import { getConfig } from '../modules';

const trimLeadingSlashes = (value: string): string => {
    let start = 0;
    while (start < value.length && value[start] === '/') {
        start++;
    }
    return value.slice(start);
};

const trimTrailingSlashes = (value: string): string => {
    let end = value.length;
    while (end > 0 && value[end - 1] === '/') {
        end--;
    }
    return value.slice(0, end);
};

const removeUntilAssets = (value: string): string => {
    const assetIndex = value.indexOf('assets');
    if (assetIndex === -1) return value;

    let start = assetIndex + 'assets'.length;
    if (value[start] === '/') {
        start++;
    }

    return value.slice(start);
};

export const getImageUrl = (path: string): string => {
    if (!path) return '';

    const cleaned = trimLeadingSlashes(removeUntilAssets(path));
    const mediaUrl = trimTrailingSlashes(getConfig('mediaUrl'));

    return `${mediaUrl}/${cleaned}`;
};
